import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL } from '../legalInfo';
import { PublicHeader, PublicFooter } from './LandingPage';

// The support page. Required by Apple: App Store Connect takes a Support URL
// as a mandatory field and a reviewer opens it, so a 404 or a redirect to the
// marketing page is a rejection on its own.
//
// Deliberately NOT built on LegalShell. That shell prints a "Draft - not yet
// legally reviewed" banner, which is right for the policy pages while they
// await a solicitor, and quite wrong on the page a customer reaches when
// something is broken.
//
// Written to be useful rather than to satisfy a form: the three things someone
// arriving here actually wants are how to reach a human, how long that takes,
// and what to include so the first reply is not a request for more detail.
function Mail({ address }) {
  return <a href={`mailto:${address}`}>{address}</a>;
}

export default function SupportPage() {
  return (
    <div className="public">
      <PublicHeader showLogin />
      <main className="public-main page-narrow">
        <h1>Support</h1>
        <p className="sub">Help with {LEGAL.companyName}&rsquo;s apps and web app.</p>

        <div className="card legal-body">
          <h2 className="legal-h">Contact us</h2>
          <p>
            Email <Mail address={LEGAL.supportEmail} /> and a person will reply. We aim to
            answer within one working day, Monday to Friday, UK time.
          </p>

          <h2 className="legal-h">What to include</h2>
          <p>So the first reply solves it rather than asking for more:</p>
          <ul className="legal-list">
            <li>The email address you sign in with, and your organisation&rsquo;s name.</li>
            <li>The project and document involved, if it concerns one.</li>
            <li>What you expected to happen, and what happened instead.</li>
            <li>A screenshot, if there is anything on screen worth seeing.</li>
          </ul>
          <p>
            Please do not send passwords or AI provider keys. We will never ask you for
            either.
          </p>

          <h2 className="legal-h">Getting an account</h2>
          <p>
            Accounts are created by an administrator at your own organisation, who invites
            you from the Team page. If you do not know who that is, email us and we will
            point you at the right person. There is nothing to buy inside the apps.
          </p>

          <h2 className="legal-h">Signing in</h2>
          <p>
            Sign in uses Microsoft Entra ID with your work account. If you do not have a
            Microsoft account, you will be sent a one-time code by email instead of being
            asked for a password. That code is requested again when your session expires,
            which is a Microsoft security setting rather than a fault.
          </p>

          <h2 className="legal-h">Privacy and your data</h2>
          <p>
            Your documents stay in your organisation&rsquo;s own workspace and answers are
            built only from your own records. See our <Link to="/privacy">Privacy Policy</Link>,{' '}
            <Link to="/terms">Terms of Service</Link> and <Link to="/cookies">Cookie Policy</Link>.
            Data protection enquiries go to <Mail address={LEGAL.privacyEmail} />.
          </p>

          <h2 className="legal-h">Company</h2>
          <p>
            {LEGAL.companyName}, registered in {LEGAL.registeredIn}, company number{' '}
            {LEGAL.companyNumber}. Registered office: {LEGAL.registeredAddress}.
          </p>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
